export const stats = [
  { value: '+180', label: "Schede Pronte all'Uso" },
  { value: '+1.500', label: 'Istruttori Soddisfatti' },
  { value: '3.600+', label: 'Ore di Pianificazione Risparmiate' },
  { value: '99%', label: 'Lo Raccomandano' },
]

export const differenceStats = [
  { value: '+180', label: 'Schede Pronte (3-14+ anni)' },
  { value: '6', label: 'Volumi Digitali Completi' },
  { value: '100%', label: 'Download Immediato' },
]

export const beforeItems = [
  "Ore passate a cercare esercizi su YouTube all'ultimo minuto",
  'Riscaldamenti ripetitivi che annoiano le allieve',
  'Nessuna progressione tecnica chiara tra i diversi gruppi',
  'Difficoltà nel monitorare i progressi e spiegare gli errori',
  'Bambine demotivate che non vedono miglioramenti reali',
]

export const afterItems = [
  '5 minuti di revisione e sei pronto per entrare in palestra',
  'Circuiti e progressioni visive che entusiasmano le ginnaste',
  'Metodo strutturato che garantisce risultati tecnici sicuri',
  'Valutazioni, test e diplomi già pronti per ogni livello',
  'Atlete che imparano con fiducia e precisione',
]

export const recognizeItems = [
  {
    emoji: '😰',
    text: 'Arrivare in palestra senza sapere esattamente come spiegare un elemento complesso',
  },
  {
    emoji: '⏱️',
    text: 'Passare la domenica a pianificare ciò che dovrebbe richiedere minuti',
  },
  {
    emoji: '🤷',
    text: 'Faticare a trovare schede didattiche di alta qualità, visive e in italiano',
  },
  {
    emoji: '📋',
    text: "Nessuna valutazione o rubrica chiara allineata con l'anno sportivo",
  },
  {
    emoji: '😴',
    text: 'Ginnaste che restano indietro perché il materiale non è adatto al loro livello',
  },
]

export const packItems = [
  {
    emoji: '📚',
    title: '5 Volumi basati sui Livelli (3–14+ anni)',
    text: "Dalla psicomotricità infantile all'acrobatica avanzata. Tutto programmato settimana dopo settimana",
  },
  {
    emoji: '🏛️',
    title: 'Volume 6: Il Manager della Palestra',
    text: 'Il tuo sistema operativo: rubriche di valutazione, calendari, test di livello e schede di monitoraggio',
  },
  {
    emoji: '✏️',
    title: 'Script delle Lezioni Passo dopo Passo',
    text: 'Suggerimenti tecnici che ti dicono esattamente come condurre la lezione in pochi secondi',
  },
  {
    emoji: '📐',
    title: 'Grammatica Motoria Visiva',
    text: 'Grafiche di alta qualità e illustrazioni che rendono semplici i movimenti complessi',
  },
  {
    emoji: '📊',
    title: 'Valutazioni e Diplomi Finali',
    text: 'Strumenti pronti per certificare i progressi delle tue allieve a fine corso',
  },
  {
    emoji: '🔑',
    title: 'Answer Keys & Correzioni',
    text: "Guide rapide per identificare l'errore e correggerlo istantaneamente e senza stress",
  },
]

export const bonuses = [
  {
    title: 'Lezione Zero™: Avvio Rapido in 10 Minuti',
    text: "Il kit per iniziare la stagione con il piede giusto: tutto quello che devi fare nei primi 10 minuti per impostare la disciplina e l'entusiasmo.",
    was: '€19',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/07566513-8876-4bf0-af55-189ed3d5aec3.jpg',
  },
  {
    title: 'Il Potere della Parola in Palestra',
    text: 'Come comunicare con autorità e motivare le tue allieve usando la psicologia dello sport applicata.',
    was: '€27',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/f645ec84-ed89-4b4f-9117-9a6f124b9110.jpg',
  },
  {
    title: 'Stazioni Express™: 25 Circuiti Visuali',
    text: 'Mappe visive pronte da stampare e posizionare sugli attrezzi. Le bambine guardano il disegno e sanno esattamente cosa fare.',
    was: '€36',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/9c0d2618-22ee-4ed3-82da-02df7c82c394.jpg',
  },
  {
    title: 'Il Potere delle Parole in Pedana',
    text: 'Lo "script" tecnico definitivo: le parole esatte da usare per correggere la verticale, la ruota e il salto senza sprecare fiato.',
    was: '€47',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/57d45eb5-be49-4969-800d-6e7e19ef4c92.jpg',
  },
  {
    title: 'Saggio di Successo: Guida alla Coreografia',
    text: "La guida passo-passo per organizzare lo spettacolo di fine anno, dalla scelta della musica alla gestione dei grandi gruppi sul palco.",
    was: '€19',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/dd466c6c-43cd-46e0-866a-8031f85a9ce6.jpg',
  },
]

export const offerRows = [
  { label: 'GA PRONTA™ Pack (6 Volumi Digitali)', value: '€77' },
  { label: '5 Bonus Strategici Esclusivi', value: '€148' },
]

export const testimonials = [
  {
    quote:
      'Ho recuperato le mie domeniche. La progressione dai 3 ai 14 anni è esattamente ciò di cui avevo bisogno.',
    name: 'Chiara M.',
    location: 'Milano 🇮🇹',
  },
  {
    quote:
      'Il bonus Stazioni Express è geniale. Metto i fogli a terra e le bambine lavorano in autonomia.',
    name: 'Luca B.',
    location: 'Roma 🇮🇹',
  },
  {
    quote:
      'Finalmente una risorsa professionale, organizzata e pronta da stampare.',
    name: 'Elena V.',
    location: 'Torino 🇮🇹',
  },
]

export const faqs = [
  {
    q: 'Come ricevo il materiale?',
    a: "Lo scarichi istantaneamente in PDF dopo l'acquisto.",
  },
  {
    q: 'È adatto per piccole palestre?',
    a: 'Sì, è scalabile per qualsiasi numero di allieve.',
  },
  {
    q: 'Quali livelli copre?',
    a: 'Dai principianti assoluti alla pre-agonistica.',
  },
  {
    q: 'Ci sono costi mensili?',
    a: 'No. Paghi una volta, lo usi per sempre.',
  },
]
